module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('p', {
    staticClass: "tocff",
    attrs: {
      "id": "rpro"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Prologue#pro"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp",
    attrs: {
      "id": "rpt1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Part01#pt1"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART  "), _c('span', {
    staticClass: "hide"
  }), _vm._v("I")]), _c('span', {
    staticClass: "space66"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "greyf"
  }, [_vm._v("OLDER")]), _vm._v(" SLOWER "), _c('span', {
    staticClass: "greyf"
  }, [_vm._v("FATTER?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toccak",
    attrs: {
      "id": "rch1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#ch1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Aging Myth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#B1"
    }
  }, [_vm._v("Body Learning: The Athletic Fountain of Youth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Mark Allen")])]), _vm._v(" "), _c('p', {
    staticClass: "tocca",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#ch2"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The Ageless Athlete")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter02#B2"
    }
  }, [_vm._v("Sports Equipment and Aging")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Andrew Pruitt, EdD")])]), _vm._v(" "), _c('p', {
    staticClass: "tocca",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Over the Hill")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB3"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#B3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endurance Exercise and Your Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Larry Creswell, MD")])]), _vm._v(" "), _c('p', {
    staticClass: "tocp1",
    attrs: {
      "id": "rpt2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Part02#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PART II")]), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "greyf"
  }, [_vm._v("FASTER")]), _vm._v(" STRONGER "), _c('span', {
    staticClass: "greyf"
  }, [_vm._v("LEANER!")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toccak",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("The High-Performance Senior Athlete")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#B4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Senior Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Lisa Rainsberger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rB5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#B5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("High-Intensity Training and the Aging Athlete")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Ned Overend")])]), _vm._v(" "), _c('p', {
    staticClass: "tocca",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Training Basics")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05#B6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Osteoarthritis and the Aging Athlete")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("John Post, MD")])]), _vm._v(" "), _c('p', {
    staticClass: "tocca",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Advanced Training")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#B7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recovery and Crosstraining")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Amby Burfoot")])]), _vm._v(" "), _c('p', {
    staticClass: "tocca",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Rest and Recovery")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07#B8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plucking Myths: Aging Cyclists and Improved Performance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("John Howard")])]), _vm._v(" "), _c('p', {
    staticClass: "tocca",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "space6"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Body Fat")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc",
    attrs: {
      "id": "rB9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#B9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Insulin Resistance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Tim Noakes, MD")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    attrs: {
      "id": "rB10"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08#B10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Menopause")])]), _vm._v(" "), _c('p', {
    staticClass: "tocv"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Gale Bernhardt")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "repi"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Epilogue#epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rack"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Acknowledgments#ack",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rapp1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix01#app1",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix A: Workout Guidelines for Senior Athletes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rapp2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix02#app2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix B: Field Tests for Senior Athletes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rapp3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix03#app3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix C: Measuring Intensity")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rnote"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "ratc"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Contributors#atc",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rata"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Author#ata",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0df69bd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 75
// module chunks = 0